// extracted by mini-css-extract-plugin
export default {"form":"styles_form__wi5mF","inputField":"styles_inputField__0ZRMU","labelClassName":"styles_labelClassName__uvVPN","button":"styles_button__D4GmJ"};